'use client';

import Link from 'next/link';
import { analytics } from '@/lib/analytics';

const WorksWithLink = ({
  href,
  name,
  children,
}: {
  href: string;
  name: string;
  children: React.ReactNode;
}) => {
  const handleClick = () => {
    analytics.capture('tone.use_tone_link.clicked', { href, partner: name });
  };

  return (
    <Link className={'flex flex-1 flex-col items-center gap-2'} href={href} onClick={handleClick}>
      {children}
    </Link>
  );
};

export default WorksWithLink;
